import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/logo-2.svg'
import _imports_1 from '@/assets/icons/user-icon-black.svg'


const _hoisted_1 = { class: "navbar navbar-expand-md fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "collapse navbar-collapse" }
const _hoisted_8 = {
  key: 0,
  class: "navbar-nav ms-auto"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-link" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_1
}, null, -1)
const _hoisted_12 = { class: "navbar-toggler" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.getSiteLink(),
          target: "_parent"
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.username)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.username), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", _hoisted_12, [
        _createElementVNode("span", {
          id: "menu-icon",
          class: _normalizeClass(["icon-navbar", { active: _ctx.showMenu }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenu && _ctx.onToggleMenu(...args)))
        }, null, 2)
      ])
    ])
  ]))
}